import { styled } from "@material-ui/core";

export const ListContainer = styled('div')(({ theme }) => ({
  [theme.breakpoints.down("sm")]: {
    width: "100%",
    "&.activated": {
      display: "none",
    },
  },
  [theme.breakpoints.up("md")]: {
    width: "288px",
    minWidth: "288px",
  },
  [theme.breakpoints.up("lg")]: {
    width: "360px",
    minWidth: "360px",
  },
  ["@media (min-width:1921px)"]: {
    width: "390px",
    minWidth: "390px",
  },
}));
